import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <nav>
      <ul>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/Projects">Projects</Link>
        </li>
        <li>
          <Link to="/Resume">Resume</Link>
        </li>
        <li
          className="dropdown"
          onMouseEnter={toggleDropdown}
          onMouseLeave={toggleDropdown}
        >
          <span className="dropdown-toggle">
            Portfolio <span className={`arrow ${isDropdownOpen ? 'open' : ''}`}>&#9662;</span>
          </span>
          {isDropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <Link to="/portfolio">Artwork</Link>
              </li>
              <li>
                <Link to="/photos">Photos</Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <Link to="/blog">Blog</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;